import { toColorString } from 'polished';
import styled from 'styled-components';

export const DescriptionSpan = styled.span`
  color: ${({
    theme: {
      colors: {
        functional: { darkGray },
      },
    },
  }) => darkGray};
`;

export const DetailsGrid = styled.div`
  display: grid;
  grid-template-columns: 130px 250px 1fr;
  grid-column-gap: 80px;
  margin-top: -32px;
  color: ${({
    theme: {
      colors: {
        functional: { darkGray },
      },
    },
  }) => darkGray};
`;

export const SectionTitle = styled.h4`
  font-family: ${({
    theme: {
      fonts: { archivo },
    },
  }) => archivo};
  display: flex;
  color: ${({ theme }) => theme.colors.functional.darkestGray};
  justify-content: space-between;
`;

export const ArrowWrapper = styled.div`
  fill: ${({
    theme: {
      colors: {
        primary: { main },
      },
    },
  }) => main};
  width: 24px;
`;

export const Group = styled.div`
  padding: 23px 0;
`;

export const GroupHeading = styled.h4`
  font-size: 1.4rem;
  font-family: ${({
    theme: {
      fonts: { archivo },
    },
  }) => archivo};
  color: ${({
    theme: {
      colors: {
        functional: { darkGray },
      },
    },
  }) => darkGray};
`;

export const Data = styled.div`
  padding-top: 0.5rem;
  font-size: 1.4rem;
`;

export const CoinWrapper = styled.span`
  display: inline-flex;
  width: 16px;
  height: 16px;
  background: ${({
    theme: {
      colors: {
        secondary: { green },
      },
    },
  }) => green};
  border-radius: 100%;
  position: relative;
  top: 3px;
  margin-right: 4px;
`;
